"use client";
import { Collapsible } from "@base-ui/react";
import { Dialog } from "@base-ui/react/dialog";
import { ChevronDownIcon, XIcon } from "lucide-react";
import type { VaccineResponse } from "../../_components/types";

interface ResultDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  result: VaccineResponse | null;
}

export const ResultDialog = ({
  open,
  onOpenChange,
  result,
}: ResultDialogProps) => {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm transition-opacity" />
        <Dialog.Popup className="fixed top-1/2 left-1/2 z-50 flex w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-3xl bg-white shadow-2xl outline-none overflow-hidden max-h-[85vh]">
          <div className="flex items-center justify-between px-6 py-4 shrink-0">
            <Dialog.Title className="text-xl font-bold text-gray-900">
              Aşı Takvimi
            </Dialog.Title>
            <Dialog.Close className="rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
              <XIcon className="size-5" />
            </Dialog.Close>
          </div>

          {result ? (
            <div className="overflow-y-auto flex-1">
              {result.vaccines.map((group) => (
                <div key={group.title}>
                  <div className="flex items-center justify-between bg-gray-100 px-4 py-2">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      {group.title}
                    </span>
                    <span className="text-xs text-gray-500">{group.dateText}</span>
                  </div>
                  <div className="divide-y divide-gray-100">
                    {group.items.map((item) => (
                      <Collapsible.Root key={`${group.title}-${item.name}`}>
                        <Collapsible.Trigger className="group flex w-full items-center justify-between px-4 py-4 text-left">
                          <span className="text-sm font-medium text-gray-800">
                            {item.name}
                          </span>
                          <ChevronDownIcon className="size-4 text-gray-400 transition-transform duration-200 group-data-open:rotate-180" />
                        </Collapsible.Trigger>
                        <Collapsible.Panel className="h-(--collapsible-panel-height) overflow-hidden transition-all duration-200 ease-out">
                          <p className="px-4 pb-4 text-xs text-gray-600 leading-relaxed">
                            {item.description}
                          </p>
                        </Collapsible.Panel>
                      </Collapsible.Root>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="px-6 py-4 text-sm text-gray-500">Sonuç bulunamadı.</p>
          )}

          <div className="px-6 py-4 shrink-0">
            <Dialog.Close className="w-full rounded-full bg-[#3b82c4] py-4 text-base font-semibold text-white transition-colors hover:bg-[#2d6ea8]">
              Tekrar Hesapla
            </Dialog.Close>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
